// Passkeys: einrichten, auflisten, entfernen (Anmelden: loginWithPasskey in authService)
import { browserSupportsWebAuthn, startRegistration, WebAuthnError } from '@simplewebauthn/browser';
import apiService from './apiService';

/** Passkeys sind nur über HTTPS (bzw. localhost) und in aktuellen Browsern möglich */
export const isPasskeySupported = () => browserSupportsWebAuthn();

/** Abbruch durch den Nutzer (Dialog geschlossen, Zeit abgelaufen) – kein Fehler, der angezeigt werden muss */
export function isPasskeyCancel(error) {
  return ['NotAllowedError', 'AbortError'].includes(error?.name) || error?.code === 'ERROR_CEREMONY_ABORTED';
}

/** Verständliche Meldung zu Fehlern des Browsers */
export function passkeyErrorMessage(error, fallback = 'Der Vorgang konnte nicht abgeschlossen werden.') {
  if (error?.name === 'InvalidStateError' || error?.code === 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED') {
    return 'Auf diesem Gerät ist bereits ein Passkey für dein Konto eingerichtet.';
  }
  return error?.message && !(error instanceof WebAuthnError) ? error.message : fallback;
}

/** Kurzer Name für das aktuelle Gerät, z. B. „iPhone“ oder „Windows-PC“ */
export function guessDeviceName(ua = navigator.userAgent, platform = navigator.userAgentData?.platform || '') {
  const text = `${platform} ${ua}`;
  if (/iPhone/i.test(text)) return 'iPhone';
  if (/iPad/i.test(text) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) return 'iPad';
  if (/Android/i.test(text)) return 'Android-Gerät';
  if (/Mac/i.test(text)) return 'Mac';
  if (/Windows/i.test(text)) return 'Windows-PC';
  if (/Linux|CrOS/i.test(text)) return 'Linux-/ChromeOS-Gerät';
  return 'Passkey';
}

/** Neuen Passkey für das angemeldete Konto anlegen (öffnet den Dialog des Geräts) */
export async function registerPasskey(name = guessDeviceName()) {
  const { options } = await apiService.post('/auth/passkey/register/options', {});
  const response = await startRegistration({ optionsJSON: options });
  return apiService.post('/auth/passkey/register/verify', { response, name });
}

export async function listPasskeys() {
  const { passkeys } = await apiService.get('/auth/passkeys');
  return passkeys || [];
}

export const deletePasskey = (id) => apiService.delete(`/auth/passkeys/${id}`);
